export interface ContextStatus {
  state: keyof typeof ContextState
  isPending?: boolean
  isResolved?: boolean
  isRejected?: boolean
  message?: string | null
  error?: string | null
  showModal?: boolean
}

export const initialContextStatus: ContextStatus = {
  state: "idle",
  isPending: false,
  isResolved: false,
  isRejected: false,
  message: null,
  error: null,
  showModal: false
}

export enum ContextState {
  idle,
  pending,
  resolved,
  rejected
}
